<div class=" mt-4">
  <section>
    <div class="row">
      <div class="col-md-12">
        <div class="float-right">
          <button class="btn dash-btns mr-3" [routerLink]="['/PayOut/NewPayOutContact']" *ngIf="newpayout">New
            PayOut Contact </button>
          <button class="btn dash-btns mr-3" [routerLink]="['/PayOut/ManagePayOutContact']">Manage PayOut Contacts
          </button>
          <button [routerLink]="['/reports/transactions/summary']" class="dash-btns btn">Reports</button>



        </div>
      </div>
    </div>

  </section>
  <section class="mt-3">
    <div class="">
      <div class="row">
        <div class="col-md-7">
          <div class="card-1">
            <div class="row">
              <div class="col-md-12">
                
                <div class="text-center">
                  <a class="view-h gary-t  ">View PayOut Contacts</a>
                </div>

                <div class="pt-3">
                  <div class=" ">
                    <div class="row mb-3">

                      <div class="col-4 p-0"> <label>Payout Customerkey Id</label> </div>

                      <div class="col-7 p-0 view-text robot"> {{rows.PayoutCustomerkeyId}}
                      </div>
                    </div>
                    <div class="row mb-3">

                      <div class="col-4 p-0"> <label>Customer AccountId</label> </div>

                      <div class="col-7 p-0 view-text robot"> {{rows.CustomerAccountId}}
                      </div>
                    </div>
                    <div class="row mb-3">

                      <div class="col-4 p-0"> <label>Customer Id</label> </div>

                      <div class="col-7 p-0 view-text robot"> {{rows.CustomerId}}</div>
                    </div>
                    <div class="row mb-3">

                      <div class="col-4 p-0"> <label>CompanyName</label> </div>

                      <div class="col-7 p-0 view-text"> {{rows.CompanyName}}</div>
                    </div>
                    <div class="row mb-3">

                      <div class="col-4 p-0"> <label> FirstName</label></div>

                      <div class="col-7 p-0 view-text robot"> {{rows.FirstName}}</div>
                    </div>

                    <div class="row mb-3">

                      <div class="col-4 p-0"> <label>LastName </label> </div>

                      <div class="col-7 p-0 view-text"> {{rows.LastName}}</div>
                    </div>
                    <div class="row mb-3">

                      <div class="col-4 p-0"><label> Address </label> </div>

                      <div class="col-7 p-0 view-text robot"> {{rows.Address}}</div>
                    </div>
                    <div class="row mb-3">

                      <div class="col-4 p-0"> <label> City </label> </div>

                      <div class="col-7 p-0 view-text"> {{rows.City}}</div>
                    </div>
                    <div class="row mb-3">

                      <div class="col-4 p-0"> <label> State</label> </div>

                      <div class="col-7 p-0 view-text robot"> {{rows.State }}</div>
                    </div>
                    <div class="row mb-3">

                      <div class="col-4 p-0"> <label> Country</label> </div>

                      <div class="col-7 p-0 view-text robot"> {{rows.Country }}</div>
                    </div>
                    <div class="row mb-3">

                      <div class="col-4 p-0"> <label>ZipCode</label> </div>

                      <div class="col-7 p-0 view-text robot"> {{rows.ZipCode}}</div>
                    </div>
                    <div class="row mb-3">

                      <div class="col-4 p-0"><label> MobileNo </label> </div>

                      <div class="col-7 p-0 view-text robot"> {{rows.MobileNo}}</div>
                    </div>
                    <div class="row mb-3">

                      <div class="col-4 p-0"><label> MobileNo2</label> </div>

                      <div class="col-7 p-0 view-text robot"> {{rows.MobileNo2}}</div>
                    </div>
                    <div class="row mb-3">

                      <div class="col-4 p-0"><label> Email </label> </div>

                      <div class="col-7 p-0 view-text"> {{rows.Email}}</div>
                    </div>
                    <div class="row mb-3">

                      <div class="col-4 p-0"><label> Email2 </label> </div>

                      <div class="col-7 p-0 view-text"> {{rows.Email2}}</div>
                    </div>
                    <div class="row mb-3">

                      <div class="col-4 p-0"><label> DateTime </label> </div>

                      <div class="col-7 p-0 view-text"> {{rows.UpdatedDatetime | date:'d/M/yy, h:mm a' }}</div>
                    </div>
                    <div class="row">
                      <div class="col-md-12  p-0">
                        <div class="border-bottom mt-3">
                          <a class="accordion" (click)="toggleAccordian($event)">UserDefined </a>
                          <div class="panel text-left mt-3" hide="!item.isActive">
                            <div class="row border-bottom p-1 my-3">

                              <div class="col-5"><label> UserDefined1 </label> </div>

                              <div class="col-7 p-0 view-text"> {{rows.UserDefined1}}</div>
                            </div>
                            <div class="row border-bottom p-1 my-3">

                              <div class="col-5"><label> UserDefined2 </label> </div>

                              <div class="col-7 p-0 view-text"> {{rows.UserDefined2}}</div>
                            </div>
                            <div class="row border-bottom p-1 my-3">

                              <div class="col-5"><label> UserDefined3 </label> </div>

                              <div class="col-7 p-0 view-text"> {{rows.UserDefined3}}</div>
                            </div>
                            <div class="row border-bottom p-1 my-3">

                              <div class="col-5"><label> UserDefined4 </label> </div>

                              <div class="col-7 p-0 view-text"> {{rows.UserDefined4}}</div>
                            </div>
                            <div class="row border-bottom p-1 my-3">

                              <div class="col-5"><label> UserDefined5 </label> </div>

                              <div class="col-7 p-0 view-text"> {{rows.UserDefined5}}</div>
                            </div>
                            <div class="row border-bottom p-1 my-3">

                              <div class="col-5"><label> UserDefined6 </label> </div>

                              <div class="col-7 p-0 view-text"> {{rows.UserDefined6}}</div>
                            </div>
                            <div class="row border-bottom p-1 my-3">

                              <div class="col-5"><label> UserDefined7 </label> </div>

                              <div class="col-7 p-0 view-text"> {{rows.UserDefined7}}</div>
                            </div>
                            <div class="row border-bottom p-1 my-3">

                              <div class="col-5"><label> UserDefined8 </label> </div>

                              <div class="col-7 p-0 view-text"> {{rows.UserDefined8}}</div>
                            </div>
                            <div class="row border-bottom p-1 my-3">

                              <div class="col-5"><label> UserDefined9 </label> </div>

                              <div class="col-7 p-0 view-text"> {{rows.UserDefined9}}</div>
                            </div>
                            <div class="row border-bottom p-1 my-3">

                              <div class="col-5"><label> UserDefined10 </label> </div>

                              <div class="col-7 p-0 view-text"> {{rows.UserDefined10}}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="text-left pt-3">

                      <button class="btn dash-btns mr-2" id="Savecoupon" color="primary"
                        (click)="viewBeneficiarie()">View
                        Beneficiary </button>

                      <button class="btn dash-btns mr-2" id="AddSavecoupon" color="primary"
                        [routerLink]="['/PayOut/AddBeneficiaries',{Id:this.Bid}] " *ngIf="Addbenficiary && hidebeneficiary">Add Beneficiary </button>

                        <span *ngIf="CreatePayOutSecuritybtn && PayOutSecuritybtn" class="mr-2">
                          <button class="btn dash-btns "  id="AddSavecoupon" color="primary"
                          [routerLink]="['/PayOut/PayoutAccountdetails',{PayOutId:rows.CustomerAccountId}] ">PayOut Security </button></span>    
                      <!-- <span *ngIf="Accountcreate"> -->
                        <span *ngIf="CreateAccountbtn && Accountcreate && VirtualAccount" class="mr-2"><button class="btn dash-btns" id="AddSavecoupon" color="primary"
                          (click)="CreateVirtualAccountbasedonprocessor(1)">Customer Virtual Account </button></span>  
                         
                         
                          
                          <span *ngIf="customeraccountbtn" class="mr-2"><button class="btn dash-btns " id="AddSavecoupon" color="primary"
                            (click)="CreateVirtualAccountbasedonprocessor(2)" >View Customer Virtual Account Details </button></span>  
                         

                            
                         
                              <span *ngIf="CreatePayOutSecuritybtn && PayOutSecuritybtn"  class="btn button px-2 py-2" >
                                <button class="btn dash-btns mr-2"  id="AddSavecoupon" color="primary"
                                 (click)="PayOutSecurity()" >View PayOut Security </button></span>  
                           
                      <!-- </span> -->
                        

                      <!-- <button class="btn box-button px-3 py-2" 
                          id="AddSavecoupon" color="primary" style="font-size: 17px;"
                          [routerLink]="['/PayOut/VirtualAccount',{Id:this.Bid}] "
                          > Customer VirtualAccount Info </button>  -->
                      <!-- [disabled]="PayoutCustomerkeyId.invalid || CustomerId.invalid || CompanyName.invalid ||FirstName.invalid|| Address.invalid || City.invalid || State.invalid || ZipCode.invalid || Country.invalid || MobileNo.invalid || Email.invalid" -->
                    </div>






                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div class="col-md-5">
          <div class="card-1">
            <div>
              <img src="https://fastswiff.com/assets/img/vpos-tour-images/payout/manage-payout.png" class="w-100" alt="">
           </div>
          </div>
        </div>
      </div>
      <div class="row px-4" *ngIf="viewBeneficiariedetails">
        <div class="container">
          <div class="row ">


            <div class="col-md-12">
              <div class="float-right">
                <button class="btn dash-btns" type="button" id="filtering" (click)="filters()"> <i
                    class="filter-icon">&nbsp;</i> Filter</button>

                <!-- <button class="box-button mr-3" type="button" data-toggle="dropdown">Export as  &nbsp;<i class="fas fa-caret-down"></i>
                  </button>
                  <ul class="dropdown-menu text-center">
                    <li><a href="" id="btnExportBatch" (click)="readAndExportToExcelData()" >Excel</a></li>
                    
                  </ul> -->
              </div>


            </div>
            <div class="col-md-12">
              <small class=" font-16 gary-t ">Currently we are displaying last 7 days report. For more details please
                click on
                Filter</small>
            </div>
          </div>
          <div class="row  my-4" *ngIf="filtering">
            <div class="col-md-12">
              <div class="card-1 p-4">
                <h4 class="font-26 gary-t">Filter Your Result</h4>
                <p>Please Fill the details to filter your result</p>
                <div class="col-md-12">
                  <!-- filtering starts -->
                  <form>
                    <div class="row m-0">
                      <div class="col-md-3 mt-4">
                        <label>Date</label>
                        <div class="form-group">
                          <ngx-select [items]="Range" id="daterange" placeholder="Today" [formControl]="daterange"
                            (ngModelChange)="checkRangeType()" required>
                          </ngx-select>
                        </div>
                      </div>
                      <div class="col-md-3 mt-4" *ngIf="Rfromdate">

                        <label>From Date</label>
                        <!-- <div class="form-group">
                          <input type="date" class="formcontrol-user form-control" placeholder="From Date" id="fromdate"
                            [formControl]="fromdate" max="{{datePickerMaxDate}}" (change)="checkDateRange()">
                        </div> -->
                        <div class="form-group">
                          <input type="date" class="formcontrol-user form-control" placeholder="From Date" id="fromdate"
                            [formControl]="fromdate" (change)="checkDateRange()">
                        </div>

                      </div>
                      <div class="col-md-3 mt-4" *ngIf="Rfromdate">
                        <label>To Date</label>
                        <!-- <div class="form-group">
                          <input type="date" class="formcontrol-user form-control" placeholder="To Date" id="todate"
                            [formControl]="todate" max="{{datePickerMaxDate}}" (change)="checkDateRange()">
                        </div> -->
                        <div class="form-group">
                          <input type="date" class="formcontrol-user form-control" placeholder="To Date" id="todate"
                            [formControl]="todate"  (change)="checkDateRange()">
                        </div>
                      </div>
                      <span class="text-danger" *ngIf="isStartDateGreaterthenEndDate">From Date Should not be
                        greater than To
                        Date</span>

                      <div class="col-md-3  mt-4">
                        <label>PayOut Beneficiary KeyId</label>
                        <div class="form-group">
                          <input type="text" class="formcontrol-user form-control"
                            placeholder="PayOut Beneficiary KeyId" id="PayOutBeneficiaryKeyId"
                            [formControl]="PayOutBeneficiaryKeyId">
                        </div>
                      </div>


                      <div class="col-md-3  mt-4">
                        <label>Account No</label>
                        <div class="form-group">
                          <input type="text" class="formcontrol-user form-control" placeholder="Account No"
                            id="AccountNo" [formControl]="AccountNo">
                        </div>
                      </div>
                      <div class="col-md-3  mt-4">
                        <label>Bank Name</label>
                        <div class="form-group">
                          <input type="text" class="formcontrol-user form-control" placeholder="BankName" id="BankName"
                            [formControl]="BankName">
                        </div>
                      </div>

                    </div>
                  </form>
                  <!-- filtering ends -->
                </div>
                <div class="col-md-12 text-right">
                  <div class="text-right mt-3" *ngIf="!isCustomDateSelected">
                    <button class="btn dash-btns" type="button" id="filtering" (click)="selectedaterange()"
                      matTooltip="New Sale Transaction"> Search</button>
                  </div>

                  <div class="text-right mt-3" *ngIf="isCustomDateSelected">
                    <button class="btn dash-btns" type="button" id="filtering" [disabled]="!isreportsbtnActive"
                      (click)="search()" matTooltip="New Sale Transaction"> Search</button>
                  </div>
                  <!-- <a href="" style="color: #d40055;">Clear</a> -->
                </div>
              </div>
            </div>
          </div>
        </div>
       

        <div class="col-md-12 p-0 mt-2">
          <div>
           
            <!-- <ngx-datatable #table class='bootstrap no-detail-row' [columnMode]="'Force'" [footerHeight]="50" -->
              <ngx-datatable #table class='bootstrap no-detail-row'  [footerHeight]="50"
              [rowHeight]="'auto'"[columnMode]="'force'" [scrollbarH]="true" [limit]="10" [rows]="row">
              <ngx-datatable-column name="Action">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <a class=" edit" [routerLink]="['/PayOut/ViewBeneficiaries',{Id: row.Id}]" data-toggle="tooltip"
                    data-placement="top" title="View">
                    <img src="./assets/ViewDetails.svg">
                  </a>
                  <a class=" edit pl-1 d-inline" *ngIf="row.Status==1 && editbenificiary"
                    [routerLink]="['/PayOut/AddBeneficiaries',{EditId:row.Id}] " data-toggle="tooltip"
                    data-placement="top" title="Edit"> <em class="fas fa-edit mr-2"></em>
                  </a>
                  <!-- <a class="edit pl-1 d-inline" [routerLink]="['/PayOut/DeleteBeneficiarie',{Id: row.Id}]"
                    data-toggle="tooltip" data-placement="top" title="Delete" *ngIf="deletebenificiary">
                    <em class="far fa-trash-alt"></em>
                  </a> -->

                </ng-template>
              </ngx-datatable-column>

              <!-- [width]="200" -->
              <!-- <ngx-datatable-column name="Status">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <span class="status-warning-btn " *ngIf="row.Status==1">
                  Pending
                </span>
                <span class="status-approved-btn" *ngIf="row.Status==2">
               Approved
                </span>
              
              </ng-template>
            </ngx-datatable-column> -->
              <ngx-datatable-column name="Status check" [width]="200">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <span *ngIf="row.Status==1 && verifystatus ">
                    <span class="status-warning-btn"
                      (click)="verificationbenficiarie(row.PayOutBeneficiaryKeyId)">Verify beneficiary</span>
                  </span>
                  <span *ngIf="row.Status==2">
                    <span class="status-approved-btn">Verified</span>
                  </span>
                </ng-template>
              </ngx-datatable-column>
              <!-- <ngx-datatable-column name="PayoutCustomerkeyId"  [width]="200">
              <ng-template let-row="row" ngx-datatable-cell-template> {{row.PayoutCustomerkeyId}}
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="PayOutBeneficiaryKeyId">
              <ng-template let-row="row" ngx-datatable-cell-template> {{row.PayOutBeneficiaryKeyId}} </ng-template>
            </ngx-datatable-column>
     -->
              <ngx-datatable-column name="AccountNumber" [width]="200">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <div class="robot font400">{{row.AccountNumber}}</div>
                </ng-template>

              </ngx-datatable-column>
              <ngx-datatable-column name="Beneficiary Name">
                <ng-template let-row="row" ngx-datatable-cell-template> {{row.BeneficiaryName}}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="BankName">
                <ng-template let-row="row" ngx-datatable-cell-template> {{row.BankName}}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="BranchName">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <div class=" robot font400">{{row.BranchName}}</div>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="UpdatedDatetime">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <div class=" robot font400">{{row.UpdatedDatetime | date:'d/M/yy, h:mm a' }}</div>
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
          </div>
        </div>
      </div>

      <div class="col-md-12 pt-3" *ngIf="!ZerpProcessors">
      <tabset [justified]="true" class="ie-fix-flex">
        <tab *ngIf="IndusBankInfo">
          <ng-template tabHeading><button class="btn-block btn vbt-btn   " id="cardpaymentprocessorbtn" > Indus Bank </button> </ng-template>           
          <div class="col-md-8 offset-md-2 pt-2" *ngIf="IndusBankInfo">

        

            <div class="card-1">
               
                <h4 class="gary-t pt-35 font-20">Indus Bank Details </h4>
                <div class="pt-35">
                    <div *ngIf="IndusBankInfo">
                        <div class=" ">
                        <div class="">
                          <div class="row">
                          </div>
                        </div>
    
                        <div class="row  m-3">
                          <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">CustomerAccountKeyId:</label> </div>
                          <div class="col-7 p-0 view-text"> {{IndusPayoutAccountKeyId}}</div>
                      </div>
                      <div class="row  m-3">
                        <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">AccountNo:</label> </div>
                        <div class="col-7 p-0 view-text"> {{IndusAccountNo}}</div>
                    </div>
                    <div class="row  m-3">
    
                      <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">BankCode:</label> </div>
    
                      <div class="col-7 p-0 view-text"> {{IndusBankCode}}</div>
                           </div>
                            <div class="row  m-3">
    
                                <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">AccountHolderName:</label> </div>
    
                                <div class="col-7 p-0 view-text"> {{IndusAccountHolderName}}</div>
                            </div>
    
                           
                          <div class="row  m-3">
    
                            <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">Address:</label> </div>
    
                            <div class="col-7 p-0 view-text"> {{IndusAddress}}, {{IndusCity}},
                              {{IndusState}}, {{IndusZipCode}}</div>
                              </div>
    
    
                            <div class="row  m-3">
    
                                <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">UpdatedDateTime:</label> </div>
    
                                <div class="col-7 p-0 view-text robot"> {{IndusUpdatedDatetime}}</div>
                            </div>
                          
                           
                        </div> 
                   
                    </div>
                </div>
            </div>
        </div>
        </tab>
    
        <tab *ngIf="AxisBankInfo">
          <ng-template tabHeading><button class="btn-block btn vbt-btn   " id="cardpaymentprocessorbtn"  > Axis Bank </button> </ng-template>           
  

    <div class="col-md-8 offset-md-2 pt-2" *ngIf="AxisBankInfo">

        

      <div class="card-1">
         
          <h4 class="gary-t pt-35 font-20">Axis Bank details </h4>
          <div class="pt-35">
              <div>
                  <div class=" ">
                  <div class="">
                    <div class="row">
                    </div>
                  </div>

                  <div class="row  m-3">
                    <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">CustomerAccountKeyId:</label> </div>
                    <div class="col-7 p-0 view-text"> {{AxisPayoutAccountKeyId}}</div>
                </div>
                <div class="row  m-3">
                  <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">AccountNo:</label> </div>
                  <div class="col-7 p-0 view-text"> {{AxisBankAccountNo}}</div>
              </div>
              <div class="row  m-3">

                <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">BankCode:</label> </div>

                <div class="col-7 p-0 view-text"> {{AxisBankBankCode}}</div>
                     </div>
                      <div class="row  m-3">

                          <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">AccountHolderName:</label> </div>

                          <div class="col-7 p-0 view-text"> {{AxisBankAccountHolderName}}</div>
                      </div>

                     
                    <div class="row  m-3">

                      <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">Address:</label> </div>

                      <div class="col-7 p-0 view-text"> {{AxisBankAddress}}, {{AxisBankCity}},
                        {{AxisBankState}}, {{AxisBankZipCode}}</div>
                        </div>


                      <div class="row  m-3">

                          <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">UpdatedDateTime:</label> </div>

                          <div class="col-7 p-0 view-text robot"> {{AxisBankUpdatedDatetime}}</div>
                      </div>
                    
                     
                  </div> 
             
              </div>
          </div>
      </div>
  </div>
      </tab>

      <tab *ngIf="yesBankInfo">
        <ng-template tabHeading><button class="btn-block btn vbt-btn   " id="cardpaymentprocessorbtn"  > Yes Bank </button> </ng-template>           


  <div class="col-md-8 offset-md-2 pt-2">

      

    <div class="card-1">
       
        <h4 class="gary-t pt-35 font-20">Yes Bank details </h4>
        <div class="pt-35">
            <div>
                <div class=" ">
                <div class="">
                  <div class="row">
                  </div>
                </div>

                <div class="row  m-3">
                  <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">CustomerAccountKeyId:</label> </div>
                  <div class="col-7 p-0 view-text"> {{YesPayoutAccountKeyId}}</div>
              </div>
              <div class="row  m-3">
                <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">AccountNo:</label> </div>
                <div class="col-7 p-0 view-text"> {{YesBankAccountNo}}</div>
            </div>
            <div class="row  m-3">

              <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">BankCode:</label> </div>

              <div class="col-7 p-0 view-text"> {{YesBankBankCode}}</div>
                   </div>
                    <div class="row  m-3">

                        <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">AccountHolderName:</label> </div>

                        <div class="col-7 p-0 view-text"> {{YesBankAccountHolderName}}</div>
                    </div>

                   
                  <div class="row  m-3">

                    <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">Address:</label> </div>

                    <div class="col-7 p-0 view-text"> {{YesBankAddress}}, {{YesBankCity}},
                      {{YesBankState}}, {{YesBankZipCode}}</div>
                      </div>


                    <div class="row  m-3">

                        <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">UpdatedDateTime:</label> </div>

                        <div class="col-7 p-0 view-text robot"> {{YesBankUpdatedDatetime}}</div>
                    </div>
                  
                   
                </div> 
           
            </div>
        </div>
    </div>
</div>
    </tab>


      <tab *ngIf="accountIddetail && VirtualAccount">
        <ng-template tabHeading><button class="btn-block btn vbt-btn   " id="cardpaymentprocessorbtn"  > Create Account </button> </ng-template>           

        <div class="col-md-8 offset-md-2 pt-2" *ngIf="accountIddetail">

          <div class="card-1">
             
              <h4 class="gary-t pt-35 font-20">Create Virtual Account </h4>
              <div class="pt-35">
                  <div *ngIf="accountIddetail">
                    <label  class="customlabel">PayOut Processor Type*</label>
                    <div class="selctcustom mb-0">
                        
                    <select class="formcontrol-user form-control"
                    id="PayOutProcessorType" [formControl]="PayOutProcessorType"
                    placeholder="PayOut Processor Type"  [(ngModel)]="Processorvalue" (change)="onKey()" >
                        <option [value]="Processorvalue" disabled selected hidden>{{Processorvalue}}</option> 
                    <option *ngFor="let list of myItems">
                        {{list.PayoutProcessorId}}
    
                    </option>
    
                </select>
                    </div>
    
                    <div class="col-md-12 text-right">
                      <div class="text-right mt-3"  *ngIf="hidecustomervirtualacct">
                        <button class="btn dash-btns" type="button" (click)="CreateVirtualAccount()"
                          matTooltip="New Sale Transaction"  [disabled]="processortype"> Create Account</button>
                      </div>
                    </div>
                </div>
                
                 
              </div>
          </div>
      </div>
 
    </tab>
</tabset>
      </div>






<div class="text-center pt-4" *ngIf="CreatePayOutSecurity">
  <a class="view-h gary-t  ">Payout Security Details</a>
</div>


    <div class="row pt-2" *ngIf="CreatePayOutSecurity">
      <div class="col-md-12">
        <ngx-datatable #table class='bootstrap no-detail-row' (columnMode)="'Force'" [footerHeight]="50"
          [rowHeight]="'auto'"[columnMode]="'force'" [scrollbarH]="true" [limit]="10" [rows]="Accountdetail">
          <ngx-datatable-column name="Action" [width]="200">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <a class=" edit" [routerLink]="['/PayOut/ViewPayoutAccountdetails',{Id: row.Id}]" data-toggle="tooltip"
                data-placement="top" title="View">
                <img src="./assets/ViewDetails.svg">
              </a>
              <a class=" edit pl-3 d-inline" [routerLink]="['/PayOut/PayoutAccountdetails',{Id: row.Id}]"
                data-toggle="tooltip" data-placement="top" title="Edit"> <em class="fas mr-2 fa-edit"></em>
              </a>
              <a class="edit pl-3 d-inline" [routerLink]="['/PayOut/ViewPayoutAccountdetails',{Id: row.Id}]"
              data-toggle="tooltip" data-placement="top" title="Delete">
              <em class="far fa-trash-alt mr-2"></em>
              </a>

            </ng-template>
          </ngx-datatable-column>

          <!-- [width]="200" -->
          <ngx-datatable-column name="AccountNumber" [width]="200">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.AccountNumber}}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="IFSCCode">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.IFSCCode}} </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Customer AccountId">
            <ng-template let-row="row" ngx-datatable-cell-template> {{row.CustomerAccountId}} </ng-template>
          </ngx-datatable-column>
          

          <ngx-datatable-column name="UpdatedDateTime">
            <ng-template let-row="row" ngx-datatable-cell-template>
              <div class="robot font400">{{row.UpdatedDateTime | date:'d/M/yy, h:mm a' }}</div>
            </ng-template>

          </ngx-datatable-column>

        </ngx-datatable>
      </div>
    </div>
    </div>
  </section>
</div>